import { __awaiter } from "tslib";
import { PixelEventService } from '@websky/pixel';
import { Log } from '../../../../sentry';
export const sendPixelEvent = (buildEvent) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        if (!((_b = (_a = window.__webskyEngineConfig) === null || _a === void 0 ? void 0 : _a.global) === null || _b === void 0 ? void 0 : _b.usePixel)) {
            return;
        }
        const pixelService = PixelEventService.getInstance();
        if (!pixelService.isReady()) {
            yield pixelService.initialize();
        }
        const cdpId = pixelService.getCdpId();
        if (cdpId) {
            yield pixelService.sendEvent(buildEvent(cdpId));
        }
    }
    catch (error) {
        Log({
            level: 'error',
            message: `SendPixelEvent error: ${error instanceof Error ? error.message : String(error)}`
        });
    }
});
